import {
  CentraCheckoutApiMappers,
  defaultCentraCheckoutApiMappers,
} from "@made-people/grease-centra";

const CUSTOMER_FRIENDLY_NAME_ATTRIBUTE =
  "checkoutVoucherDisplay_customerFriendlyName";
const PREVENT_REMOVAL_ATTRIBUTE = "checkoutVoucherDisplay_preventRemoval";

const readTextAttribute = (value: unknown): string | undefined =>
  typeof value === "string" && value.trim().length > 0 ? value : undefined;

const readBooleanAttribute = (value: unknown): boolean =>
  value === true || value === 1 || value === "1";

export const mmCodeVoucher: CentraCheckoutApiMappers["centraCheckoutApiVoucherToGreaseCodeVoucher"] =
  (voucher) => {
    const base =
      defaultCentraCheckoutApiMappers.centraCheckoutApiVoucherToGreaseCodeVoucher(
        voucher,
      );
    const attributes =
      voucher.attributes && !Array.isArray(voucher.attributes)
        ? voucher.attributes
        : {};

    return {
      ...base,
      displayName: readTextAttribute(
        attributes[CUSTOMER_FRIENDLY_NAME_ATTRIBUTE],
      ),
      isRemovable: !readBooleanAttribute(attributes[PREVENT_REMOVAL_ATTRIBUTE]),
    };
  };
